define(['ErgonTech_Mage2LayerApi/js/toggle-filter-actions'], function(toggle) {
    "use strict";

    return function(Mage2LayerUi) {
        var originalFunction = Mage2LayerUi.prototype.applyUrlState;

        Mage2LayerUi.prototype = jQuery.extend(Mage2LayerUi.prototype, {
            applyUrlState: function(urlState, api) {
                originalFunction(urlState, api);
                toggle.activateActions();
            }
        });

        return Mage2LayerUi;
    };
});
